var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('canvas',{staticClass:"fixed top-0 left-0",attrs:{"id":"global-drag-canvas","width":_setup.width,"height":_setup.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }